module.exports = __webpack_public_path__ + "img/download-chrome.03408b21.png";